import React from "react";
import { Route, Switch } from "react-router-dom";
import AdminMenu from "src/Components/AdminMenu";
import styled from "styled-components";
import AdminDashboard from "../AdminDashboard";
import Packages from "../Packages";
import Products from "../Products";
import AdminRestockOrders from "../AdminRestockOrders";
import ShipmentOrders from "../ShipmentOrders";
import AdminAgents from "../AdminAgents";
import AdminCashWithdrawal from "../AdminCashWithdrawal";
import AdminGallery from "../AdminGallery";
import AdminBrandArticles from "../AdminBrandArticles";
import BusinessSettings from "../BusinessSettings";
import { Helmet } from "react-helmet-async";
import NotFound from "src/Routes/NotFound";
import CountriesShipping from "../CountriesShipping";

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  min-height: 100vh;
  min-width: 100vw;
`;
const AdminLayout = () => {
  return (
    <Container>
      <Helmet>
        <title>Admin Dashboard</title>
      </Helmet>
      <AdminMenu />
      <Switch>
        <Route exact path="/admin" component={AdminDashboard} />
        <Route exact path="/admin/products" component={Products} />
        <Route exact path="/admin/products/:productId" component={Products} />
        <Route exact path="/admin/packages" component={Packages} />
        <Route exact path="/admin/agents" component={AdminAgents} />
        <Route exact path="/admin/agents/:uid" component={AdminAgents} />
        <Route
          exact
          path="/admin/restock_orders"
          component={AdminRestockOrders}
        />
        <Route
          exact
          path="/admin/restock_orders/:page"
          component={AdminRestockOrders}
        />
        <Route
          exact
          path="/admin/countries_and_shipping/"
          component={CountriesShipping}
        />
        <Route
          exact
          path="/admin/shipment_orders/"
          component={ShipmentOrders}
        />
        <Route
          exact
          path="/admin/shipment_orders/:order_type"
          component={ShipmentOrders}
        />
        <Route
          exact
          path="/admin/cash_wallet"
          component={AdminCashWithdrawal}
        />
        <Route
          exact
          path="/admin/cash_wallet/:cash_type"
          component={AdminCashWithdrawal}
        />
        <Route exact path="/admin/gallery" component={AdminGallery} />
        <Route
          exact
          path="/admin/brand_articles"
          component={AdminBrandArticles}
        />
        <Route exact path="/admin/settings" component={BusinessSettings} />
        <Route component={NotFound} />
      </Switch>
    </Container>
  );
};

export default AdminLayout;
